module.exports = __webpack_public_path__ + "static/chainsulting-d833f9b90dc3a305bc44931716ef35ca.svg";